import { getFlags } from '@telstra-connect/order-tracker/feature-flags';

export const isOrderListCloumnChange = (isInternationalUser: boolean) => {
    const orderColumnFlag = getFlags().orderListColumnChanges;
    const isCheckFlag = (orderColumnFlag &&  !isInternationalUser) ? true : false;
    return isCheckFlag;

};
